export default abstract class IDrawPivot {
  public abstract drawPivotData(): void;
  public abstract draw(): void;
}
